module.exports = __webpack_public_path__ + "static/img/1-1.8245c88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/eng/1-1.png
// module id = h8nZ
// module chunks = 0